// extracted by mini-css-extract-plugin
export default {"main":"main--E3vWd","content":"content--hyR61","top":"top--q7JNq","header":"header--Aj1k4","logo":"logo--Uv7hC","message":"message--xArRd","title":"title--Z86iJ"};